import React, {Component} from 'react';
import {Modal, ToggleButton, ToggleButtonGroup} from 'react-bootstrap';
import RandomAssessmentButton from './RandomAssessmentButton';
import GreenLeafApi from '../utils/GreenLeafApi';
import {withRouter} from 'react-router';

class DevModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isGroupForm: false,
      form: {}
    };
  }

  updateFormState = (event) => {
    const field = event.target.name;
    let state = this.state.form;
    state[field] = event.target.value;
    return this.setState(state);
  };

  addRandomAssessment = (event) => {
    event.preventDefault();
    let date = this.state.form;
    date = new Date(date.year, date.month-1, date.day);
    if(this.state.isGroupForm) {
      let rando = {teamId: this.props.match.params.teamId, date, assessment_count: this.state.form.takers};
      GreenLeafApi.GroupTeamAssessment.createRandom(rando);
    } else {
      let rando = {teamId: this.props.match.params.teamId, date};
      GreenLeafApi.TeamAssessment.createRandom(rando);
    }
  };

  render() {
    return (
      <div>
        <Modal
          show={this.props.show}
          onHide={this.props.onHide}
        >
          <Modal.Header>
            <Modal.Title>
              Developer Panel
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ToggleButtonGroup
              type='radio'
              name='options'
              value={this.state.isGroupForm}
              onChange={(value) => { this.setState({ isGroupForm: value }); }}
            >
              <ToggleButton value={true}>Group</ToggleButton>
              <ToggleButton value={false}>Coach</ToggleButton>
            </ToggleButtonGroup>
            <RandomAssessmentButton groupForm={this.state.isGroupForm} onSave={this.addRandomAssessment} onChange={this.updateFormState}/>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

DevModal.propTypes = {};

export default withRouter(DevModal);



// WEBPACK FOOTER //
// ./src/components/teams/DevModal.js